<template>
  <el-table-column
    prop="count"
    label="Db."
    show-overflow-tooltip
    align="right"
  >
    <template slot-scope="scope">
      {{ scope.row.count }} db
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'count',
};
</script>
